import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faChartBar, faBell } from '@fortawesome/free-solid-svg-icons';
import './Dashboard.css';
import { useAuth } from '../../context/AuthContext';
import { faUserCircle, faMoneyBillWave, faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';
import api from '../../api';
import axios from 'axios';
import { useSocket } from '../../context/SocketContext';

const Sidebar = () => {
  // const { logout } = useAuth();
  const { token } = useAuth();
  const { socket } = useSocket();
  const [expanded, setExpanded] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  
  const toggleSidebar = () => {
    setExpanded(!expanded);
  };

  // ✅ Fetch Notifications Count Initially
  useEffect(() => {
    const fetchNotificationCount = async () => {
      if (!token) return;
      try {
        // Fetch test video notifications
        const videoRes = await axios.get(api.getNewTestVideoNotifications, {
          headers: { Authorization: `Bearer ${token}` },
        });

        // Fetch course purchase notifications
        const courseRes = await axios.get(api.getCoursePurchaseNotifications, {
          headers: { Authorization: `Bearer ${token}` },
        });

        // Calculate the unread notification count
        const videoUnreadCount = videoRes.data.newVideos?.filter((notif) => notif.notification === true).length || 0;
        const courseUnreadCount = courseRes.data.notifications?.filter((notif) => notif.notification === true).length || 0;

        // Set the total notification count
        setNotificationCount(videoUnreadCount + courseUnreadCount);
      } catch (err) {
        console.error('Failed to fetch notifications:', err);
      }
    };

    fetchNotificationCount();
  }, [token]);

  // ✅ Listen for Real-Time Notifications
  useEffect(() => {
    if (!socket) return;
    const handleReceiveNotification = (newNotification) => {
      console.log('Received real-time instructor notification:', newNotification);
      setNotificationCount((prevCount) => prevCount + 1);
    };
    socket.on('receiveNotification', handleReceiveNotification);
    return () => {
      socket.off('receiveNotification', handleReceiveNotification);
    };
  }, [socket]);

  return (
    <div
      className={`sidebar ${expanded ? 'expanded' : ''}`}
      onClick={toggleSidebar} // Handle click to expand
    >
      <ul>
        <li>
          <Link to="/instructor-guide" className="sidebar-link">
            <FontAwesomeIcon icon={faChalkboardTeacher} className="sidebar-icon" />
            <span className="sidebar-text">Instructor Guide</span>
          </Link>
        </li>

        {/* Mobile-only: Notifications moved from topbar */}
        <li className="mobile-only">
          <Link to="/Instructor-notifications" className="sidebar-link sidebar-notification-link">
            <FontAwesomeIcon icon={faBell} className="sidebar-icon sidebar-bell-icon" />
            {notificationCount > 0 && (
              <span className="sidebar-notification-badge">
                {notificationCount}
              </span>
            )}
            <span className="sidebar-text">Notifications</span>
          </Link>
        </li>

        <li>
          <Link to="/my-courses" className="sidebar-link">
            <FontAwesomeIcon icon={faBook} className="sidebar-icon" />
            <span className="sidebar-text">Courses</span>
          </Link>
        </li>
        <li>
          <Link to="/performance" className="sidebar-link">
            <FontAwesomeIcon icon={faChartBar} className="sidebar-icon" />
            <span className="sidebar-text">Performance</span>
          </Link>
        </li>
        {/* <li>
          <Link to="/settings" className="sidebar-link">
            <FontAwesomeIcon icon={faCog} className="sidebar-icon" />
            <span className="sidebar-text">Settings</span>
          </Link>
        </li> */}
        <li>
          <Link to="/instructor-payout" className="sidebar-link">
            <FontAwesomeIcon icon={faMoneyBillWave} className="sidebar-icon" />
            <span className="sidebar-text">Payment</span>
          </Link>
        </li>
        {/* <li>
          <Link to="/tools" className="sidebar-link">
            <FontAwesomeIcon icon={faWrench} className="sidebar-icon" />{" "}
          
            <span className="sidebar-text">Tools</span>
          </Link>
        </li> */}

        <li>
          <Link to="/instructor-about" className="sidebar-link">
            <FontAwesomeIcon icon={faUserCircle} className="sidebar-icon" />
            <span className="sidebar-text">Edit Your Bio</span>
          </Link>
        </li>

      </ul>
    </div>
  );
};

export default Sidebar;
